import config from "../app.config";

export default {
  setCurrentUser(userInfo) {
    localStorage.setItem("orbitUser", JSON.stringify(userInfo));
  },
  getCurrentUser() {
    var user = localStorage.getItem("orbitUser");
    return user ? JSON.parse(user) : {};
  },
  resetUserPermissions() {
    let tmpUser = this.getCurrentUser();
    if (tmpUser.length) {
      //DETAIL: ONLY RESET IF A USER EXISTS
      tmpUser.permissions = {};
      this.setCurrentUser(tmpUser);
    }
  },
  setUserPermission(key, val) {
    let tmpUser = this.getCurrentUser();
    if (Object.keys(tmpUser).length) {
      tmpUser.permissions = tmpUser.permissions ?? {};
      tmpUser.permissions[key] = val;
    }
    this.setCurrentUser(tmpUser);
  },
  setMassUserPermissions(permissions) {
    let tmpUser = this.getCurrentUser();
    if (Object.keys(tmpUser).length) {
      tmpUser.permissions = tmpUser.permissions ?? {};
      for (const key in permissions) {
        if (permissions.hasOwnProperty(key)) {
          console.log("CURRENT KEY:", key);
          tmpUser.permissions[key] = permissions[key];
        }
      }
    }
    this.setCurrentUser(tmpUser);
  },
  setAuthTokenFromSuccessfulCredentials(username, userpass, clientid) {
    let orbitToken = {};
    orbitToken.authToken = btoa(`${clientid}.${username}:${userpass}`);
    orbitToken.expiration = new Date();
    orbitToken.expiration.setDate(orbitToken.expiration.getDate() + 14); //ADDING 2 WEEKS
    localStorage.setItem("orbitToken", JSON.stringify(orbitToken));
    console.log(orbitToken);
  },

  getFullOrbitToken() {
    var token = localStorage.getItem("orbitToken");
    return token ? JSON.parse(token) : null;
  },

  getBasicAuthToken() {
    var token;
    if ((token = this.getFullOrbitToken())) {
      return token["authToken"];
    }
    return null;
  },

  getBasicAuthFullString() {
    return "Basic " + this.getBasicAuthToken();
  },

  destroyToken() {
    localStorage.removeItem("orbitToken");
  },

  isAuthenticated() {
    var orbitToken = this.getFullOrbitToken();

    //HAS TOKEN VALUE
    if (orbitToken) {
      console.log(orbitToken);
      var daysRemaining = (Date.parse(orbitToken["expiration"]) - Date.now()) / 1000 / 60 / 60 / 24;
      console.log("DAYS: " + daysRemaining);

      if (daysRemaining > 0) {
        return true;
      }
    }

    return false;
  },
};
